import COLORS from './colors';

const alert = {
  styleOverrides: {
    root: {
      color: COLORS.white
    }
  }
};

export default alert;
